import { Routes } from '@angular/router';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { AGENTS_CONFIG } from './base/agents-config';

/**
 * Agents Feature Routes
 *
 * Modern Angular 21+ 패턴:
 * - Standalone components with lazy loading
 * - Role guard integration (AGENTS$READ)
 * - Child route for detail page
 */
export const agentsRoutes: Routes = [
  {
    path: AGENTS_CONFIG.routePath, // 'master/agents' (Legacy와 동일)
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/agents-list-page/agents-list-page.component'
          ).then((m) => m.AgentsListPageComponent),
        canActivate: [permissionGuard(...(AGENTS_CONFIG.permissions ?? []))],
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/agents-detail-page/agents-detail-page.component'
              ).then((m) => m.AgentsDetailPageComponent),
          },
        ],
      },
    ],
  },
];
